import React from 'react'

/** Card frame shared by every chart: title, optional subtitle, loading / empty / error states */
export const ChartCard = ({ title, subtitle, isLoading, error, isEmpty, emptyText = 'No usage in this range', children }) => (
  <div className="ai-cost-card">
    <div className="ai-cost-card-head">
      <div className="ai-cost-card-title">{title}</div>
      {subtitle && <div className="ai-cost-card-subtitle">{subtitle}</div>}
    </div>
    {error ? (
      <div className="ai-cost-state text-danger">{error.message || 'Could not load'}</div>
    ) : isLoading ? (
      <div className="ai-cost-state">Loading...</div>
    ) : isEmpty ? (
      <div className="ai-cost-state">{emptyText}</div>
    ) : (
      children
    )}
  </div>
)

/** Tooltip body: title + one row per value (swatch only for coloured series) */
export const TooltipBox = ({ title, rows }) => (
  <div className="ai-cost-tooltip">
    <div className="ai-cost-tooltip-title">{title}</div>
    {rows.map((row) => (
      <div key={row.label} className="ai-cost-tooltip-row">
        {row.color && <span className="ai-cost-swatch" style={{ background: row.color }} />}
        <span>{row.label}</span>
        <strong>{row.value}</strong>
      </div>
    ))}
  </div>
)
